import { http } from "./client";

export const fetchQuickLinksConfig = () => http.get('Links');
export const saveUserQuickLinks = ({ userLinks }) => http.put('Links/update', { userLinks });
